export default "__VITE_ASSET__Cqn3FZFL__"